import { defineStore } from "pinia";

import actions from "./actions/actions.js";
import { getters } from "./getters.js";
import { state } from "./state.ts";

export const useMainStore = defineStore("main", {
  actions,
  getters,
  state,
});
